export const PAGE_THEME_DEFAULTS = {
  header_color: '#050E38',
  accent_color: '#0b1d3d',
  hero_text_color: '#ffffff',
  body_text_color: '#374151',
  cta_color: '#c82d2d',
  headline_alignment: 'left'
};

export const COLOR_PRESETS = [
  {
    id: 'ocean',
    name: 'Ocean Blue',
    ...PAGE_THEME_DEFAULTS
  },
  {
    id: 'emerald',
    name: 'Emerald',
    header_color: '#064e3b',
    accent_color: '#10b981',
    hero_text_color: '#ffffff',
    body_text_color: '#14532d',
    cta_color: '#059669',
    headline_alignment: 'left'
  },
  {
    id: 'royal',
    name: 'Royal Purple',
    header_color: '#4c1d95',
    accent_color: '#7c3aed',
    hero_text_color: '#ffffff',
    body_text_color: '#3b0764',
    cta_color: '#7c3aed',
    headline_alignment: 'left'
  },
  {
    id: 'sunset',
    name: 'Sunset',
    header_color: '#7c2d12',
    accent_color: '#ea580c',
    hero_text_color: '#ffffff',
    body_text_color: '#7c2d12',
    cta_color: '#ea580c',
    headline_alignment: 'left'
  },
  {
    id: 'slate',
    name: 'Slate',
    header_color: '#0f172a',
    accent_color: '#475569',
    hero_text_color: '#f8fafc',
    body_text_color: '#334155',
    cta_color: '#334155',
    headline_alignment: 'left'
  }
];

export const getThemeColor = (page, key) => page.theme_colors?.[key] || page.colors?.[key] || page[key];

export const buildPageThemeStyle = page => ({
  '--cp-hero-start': getThemeColor(page, 'header_color') || PAGE_THEME_DEFAULTS.header_color,
  '--cp-hero-end': getThemeColor(page, 'accent_color') || PAGE_THEME_DEFAULTS.accent_color,
  '--cp-hero-text': getThemeColor(page, 'hero_text_color') || PAGE_THEME_DEFAULTS.hero_text_color,
  '--cp-body-text': getThemeColor(page, 'body_text_color') || PAGE_THEME_DEFAULTS.body_text_color,
  '--cp-cta-color': getThemeColor(page, 'cta_color') || PAGE_THEME_DEFAULTS.cta_color
});

export const matchesPreset = (form, preset) =>
  ['header_color', 'accent_color', 'hero_text_color', 'body_text_color', 'cta_color'].every(
    key => (getThemeColor(form, key) || PAGE_THEME_DEFAULTS[key]) === preset[key]
  );
